'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('external.pec-import', {
    views: {
      'externalContent': {
        component: 'pecImport',
      }
    }
  });
}



// WEBPACK FOOTER //
// ./client/app/features/pec-import/pec-import.routes.js